export const ASSETS_PATH = "/assets/";

export const APP_COLORS = {
  FONT: "#5F4D44",
  BACKGROUND: "#FFF",
  SECONDARY_BACKGROUND: "#F6F4F2",
  MAIN: "#565D4C",
  MAIN_LIGHT: "#899979",
  SECONDARY: "#ECE7DF",
};

export const drawerWidth = 240;
